import LifeInsuranceGuard from "./LifeInsurance_Guard";
import { lazy } from "react";
import { R_LiRoutes } from "../../utils/Routes";
import SuspenseWrapper from "../../components/CustomLazyLoading/CustomLazyLoading";

const TaxCertificate = lazy(() => import("./TaxCertificate/TaxCertificate"));
const PolicyAccountStatement = lazy(
  () => import("./PolicyAccountStatement/PolicyAccountStatement"),
);
const DetailsPage = lazy(
  () => import("../Feature_LifeInsurance/RevampedLiDetailsPage/LiDetailsPage"),
);
const PremiumReceipt = lazy(() => import("./PremiumReceipt/PremiumReceipt"));
const AddUpdateNominee = lazy(
  () => import("./AddUpdateNominee/AddUpdateNominee"),
);
const UpdatePAN = lazy(() => import("./UpdatePAN/UpdatePAN"));
const AddUpdateBankAccount = lazy(
  () => import("./AddUpdateBankAccount/AddUpdateBankAccount"),
);
const UnableToNavigate = lazy(
  () => import("../../pages/UnableToNavigate/UnableToNavigate"),
);
const PANAadharLinking = lazy(
  () =>
    import("../Feature_LifeInsurance/Dashboard/PANAadharLinking/PANAadharLinking"),
);
const Payment = lazy(() => import("../Feature_LifeInsurance/Payment/Payment"));
const UpdateProfile = lazy(
  () => import("../Feature_LifeInsurance/UpdateProfile/UpdateProfile"),
);
const PolicyServices = lazy(
  () => import("../Feature_LifeInsurance/PolicyServices/PolicyServices"),
);
const DownloadStatements = lazy(
  () =>
    import("../Feature_LifeInsurance/DownloadStatements/DownloadStatements"),
);

const LifeInsuranceRoutesFn = () => {
  return [
    {
      path: R_LiRoutes.li_baseUrl,
      element: <LifeInsuranceGuard />,
      children: [
        {
          path: R_LiRoutes.details_PolicyNumber,
          element: <SuspenseWrapper LazyLoadingComponent={DetailsPage} />,
        },
        {
          path: R_LiRoutes.details_PolicyNumber_TaxCertificate,
          element: <SuspenseWrapper LazyLoadingComponent={TaxCertificate} />,
        },
        {
          path: R_LiRoutes.details_PolicyNumber_PolicyAccountStatement,
          element: (
            <SuspenseWrapper LazyLoadingComponent={PolicyAccountStatement} />
          ),
        },
        {
          path: R_LiRoutes.details_PolicyNumber_PremiumReceipts,
          element: <SuspenseWrapper LazyLoadingComponent={PremiumReceipt} />,
        },
        {
          path: R_LiRoutes.addUpdate_nominee,
          element: <SuspenseWrapper LazyLoadingComponent={AddUpdateNominee} />,
        },
        {
          path: R_LiRoutes.details_PolicyNumber_UpdatePAN,
          element: <SuspenseWrapper LazyLoadingComponent={UpdatePAN} />,
        },
        {
          path: R_LiRoutes.detail_PolicyNumber_AddUpdateBankAccount,
          element: (
            <SuspenseWrapper LazyLoadingComponent={AddUpdateBankAccount} />
          ),
        },
        {
          path: R_LiRoutes.details_payment,
          element: <SuspenseWrapper LazyLoadingComponent={Payment} />,
        },
        {
          path: R_LiRoutes.details_update_profile,
          element: <SuspenseWrapper LazyLoadingComponent={UpdateProfile} />,
        },
        {
          path: R_LiRoutes.details_policy_services,
          element: <SuspenseWrapper LazyLoadingComponent={PolicyServices} />,
        },
        {
          path: R_LiRoutes.details_download_statements,
          element: (
            <SuspenseWrapper LazyLoadingComponent={DownloadStatements} />
          ),
        },
      ],
    },
    {
      path: R_LiRoutes.li_UrlNotFound,
      element: <SuspenseWrapper LazyLoadingComponent={UnableToNavigate} />,
    },
    {
      path: R_LiRoutes.li_PanAadharLinking,
      element: <SuspenseWrapper LazyLoadingComponent={PANAadharLinking} />,
    },
  ];
};
export { LifeInsuranceRoutesFn };
